import ClassNames from "classnames";
import { FunctionComponent, MouseEvent } from "react";
import styles from "../stylesheets/components/multi-box.module.css";
import { AspectRatio, ColorScheme, Language } from "../types/index.js";
import SliderArrow from "./SliderArrow.js";

interface Props {
  scheme: ColorScheme;
  mediaAspectRatio: AspectRatio;
  type: "prev" | "next";
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  hasImages: boolean;
  languageId: Language;
}

const MultiBoxSliderArrow: FunctionComponent<Props> = ({
  scheme,
  type,
  onClick,
  mediaAspectRatio,
  hasImages,
  languageId,
}) => (
  <div
    className={ClassNames(
      "AspectRatio",
      styles[`MultiBox__NavigationWrapper--${type}`],
      { [styles["MultiBox__NavigationWrapper--has-images"]]: hasImages },
    )}
    style={{ "--aspect-ratio": mediaAspectRatio } as React.CSSProperties}
  >
    <SliderArrow
      className={ClassNames(
        styles.MultiBox__Navigation,
        styles[`MultiBox__Navigation--${type}`],
      )}
      iconClassName={styles.MultiBox__NavigationIcon}
      scheme={scheme}
      onClick={onClick}
      direction={type === "prev" ? "left" : "right"}
      transparentBackground={false}
      languageId={languageId}
    />
  </div>
);

export default MultiBoxSliderArrow;
